import React from 'react'
import styled, { SimpleInterpolation } from 'styled-components'

const StyledImg = styled.img.attrs({
  src: 'traefikee.svg',
  alt: 'Traefik Enterprise',
})`
  height: 40px;
`

type LogoType = {
  as: 'button' | 'a'
}

const Logo = styled.div.attrs<LogoType>({
  children: <StyledImg />,
})`
  display: flex;
  border: none;
  padding: 0;
  width: auto;
  overflow: visible;
  background: transparent;

  &:focus {
    outline: none;
  }

  ${(props: LogoType): SimpleInterpolation =>
    props.as === 'button' &&
    `
    &:hover {
      cursor: pointer;
    }
  `}
`

export default Logo
